export class User {
    public userID: number;
    public age: any;
    public name: string;
    public gender: string="";
    public ageGroup:any;
    public username: string;
    public email: string;
    public objLoaderStatus: boolean;
    public authenticated: boolean;
    public email_user: string="";
    public country : number;
    public countryid : number;
    public state : number;
    public countrycode:string;
    public cname:string;
    public postcode:string;
    public fbButtonFlag : boolean=true;
    public deviceToken: any;
    public segmentIds: any[] =[0];
    public errorMsg = '';
    public successMsg:boolean;
    public servererrormsg:boolean;
    public accessToken ='';
    public src: string;
    public srcId: string;
    public locationFlag :boolean;
    public businessName : string;
    public branchCode : string;
    public contactNumber : string;
    public businessAddress :  string;
    public latitude : string;
    public password:string;
    public longitude : string;
    public isdCode : string;
    public acnAbn : string;
    public interest : any=0;
    public radius:any;
    public loaderFlag:boolean;
    public matchValue:string;
    public statename:string;
    public ipAddress:string;
    public dob:string;
    public psuccessMsg:boolean;
    public deviceType:any;
    public uservaluesearch1: string;
    public suggestionArray=[];
    public firstName : string;
    public lastName : string;
    public title : string;
    public locationSearch : string;
    constructor() {
        
    }
}


// WEBPACK FOOTER //
// ./src/app/models/user.ts